import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const DomainEnforcer = ({ children }) => {
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const hostname = window.location.hostname;
    // Check if the current domain is the alias domain
    const isAliasDomain = hostname === 'moment.reviews' || hostname === 'www.moment.reviews';

    if (isAliasDomain) {
      const path = location.pathname;
      
      // Allow access if it's a public page or an embed widget
      const isAllowedPath = path.startsWith('/p/') || path.startsWith('/embed/');

      if (!isAllowedPath) {
        setIsRedirecting(true);
        // Redirect to the main domain, keeping the exact path, search params, and hash
        const newUrl = `https://momentoftruth.io${location.pathname}${location.search}${location.hash}`;
        window.location.replace(newUrl);
      }
    }
  }, [location]);

  // Show a premium loading state while redirecting to prevent flashing the wrong URL's content
  if (isRedirecting) {
    return (
      <div className="min-h-screen bg-[#0a0500] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-2 border-orange-500/20 border-t-orange-500 rounded-full animate-spin"></div>
          <div className="text-orange-500/50 text-sm font-medium tracking-widest uppercase animate-pulse">
            Redirecting
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default DomainEnforcer;